import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'store/redux.store'

import { ACTION, CATEGORY, DataLayer, EVENT, GoogleAnalyticsDataLayer } from 'src/utils/google-analytics'
import { ReactComponent as VersionToggleSVG } from '../../assets/version-toggle.svg'

function PlatformToggle({ tabIndex }) {
  const { context } = useSelector(state => state)
  const { t } = useTranslation()
  const history = useHistory()

  function sendUserPageInteraction(label: string) {
    const dataLayer = new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_PROFILE, label)

    GoogleAnalyticsDataLayer.sendPageInteraction(dataLayer)
  }

  function handleClickGoBack() {
    sendUserPageInteraction('Back_to_old_platform_header')
    history.push('/cancel')
  }

  if (!context?.optInStatus?.optOutEnabled) {
    return null
  }
  return (
    <div slot="header-actions" className=" _d-md-flex _d-none">
      <hot-menu-item
        data-testid="toggle-item"
        slot="button"
        class="_cursor-pointer"
        onClick={handleClickGoBack}
        tabIndex={tabIndex}
      >
        <div className="hot-application-menu__icon _w-auto">
          <VersionToggleSVG />
          <p className="_m-0 _pl-1 _text-2">{t('header.menu.general.old_version')}</p>
        </div>
      </hot-menu-item>
    </div>
  )
}

export default PlatformToggle
